import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * Hyperpigmentation
   */
  {
    // 1
    field: 'hyperpigLocation',
    label: 'Where is the hyperpigmentation that you trying to treat? What % of the area is covered by hyperpigmentation?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'areaLocated',
      placeholder: 'Please type here...'
    }
  },
  {
    //2
    label:
      'Are you pregnant, breastfeeding, or planning to become pregnant in the near future?',
    field: 'pregnantFuture',
    type: 'polar_check',
    answer: {
      label: 'Please tell us more about your plans',
      name: 'pregnantFutureDesc',
      type: 'text'
    }
  },
  {
    // 3
    field: 'hyperpigUploadPicture',
    label:
      'Please upload a picture of the affected area of your skin.',
    type: 'file_upload',
    answer: [
      {
        resourceId: 'hyperpigPicture',
        buttonLabel: 'Choose file'
      }
    ]
  },
  {
    // 4
    field: 'hyperpigExtra',
    label: 'Is there anything else you would like the doctor to know?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'extraData',
      placeholder: 'Please type here...'
    }
  },
];

export default questionsModels;
